import type { ReactNode } from 'react';
import { useTranslate } from '@tolgee/react';

export function V3LoadingBlock() {
  const { t } = useTranslate();
  return (
    <div
      className="v3p-page"
      aria-busy="true"
    >
      <section
        className="v3-card v3p-center"
        data-od-id="loading-block"
      >
        <span
          className="v3p-spin"
          role="status"
          aria-label={t('v3_loading', 'Wird geladen')}
        />
      </section>
    </div>
  );
}

export function V3EmptyBlock(props: {
  readonly title: string;
  readonly text?: string;
  readonly children?: ReactNode;
}) {
  return (
    <section
      className="v3-card v3p-center"
      role="status"
      data-od-id="empty-block"
    >
      <h2>{props.title}</h2>
      {props.text && <p className="v3p-mu">{props.text}</p>}
      {props.children}
    </section>
  );
}

export function V3ErrorBlock(props: {
  readonly title?: string;
  readonly text?: string;
  readonly onRetry: () => void;
}) {
  const { t } = useTranslate();
  return (
    <section
      className="v3-card"
      role="alert"
      data-od-id="error-block"
    >
      <span className="v3-chip c-bad">{t('v3_error_chip', 'Fehler')}</span>
      <h2>
        {props.title ??
          t('v3_error_title', 'Die Seite konnte nicht geladen werden')}
      </h2>
      <p className="v3p-mu">
        {props.text ??
          t(
            'v3_error_text',
            'Die Verbindung zum Server wurde unterbrochen. Ihre Daten sind nicht betroffen.',
          )}
      </p>
      <div className="v3p-row">
        <button
          type="button"
          className="v3-btn pri"
          data-od-id="error-retry"
          onClick={props.onRetry}
        >
          {t('v3_error_retry', 'Erneut versuchen')}
        </button>
        <a
          className="v3-btn ghost"
          href={`mailto:${t('v3_support_email', 'support@agentselly.ch')}`}
        >
          {t('v3_result_error_support', 'Support kontaktieren')}
        </a>
      </div>
    </section>
  );
}
